import BaseComponent from '../abstracts/BaseComponent';
import {
  DataLayerUtils
} from '../utilities/DataLayer';

export default class RecommendedComponent extends BaseComponent {
  constructor(element) {
    super(element);
    this.recommendedProducts();
  }

  recommendedProducts() {
    var checkExist = setInterval(function () {
      if (this.length) {
        var elements = document.querySelectorAll('.glide__slide [data-pid]');
        var productImpression = [];
        clearInterval(checkExist);
        
        for (var i = 0; i < elements.length; i++) {
          productImpression.push ({
            'name': elements[i].dataset.optionName, 
              'id': elements[i].dataset.pid, 
              'price': elements[i].dataset.optionPrice, 
              'brand': 'pdb',
              'category': elements[i].dataset.optionCategory, 
              'variant': elements[i].dataset.optionVariant, 
              'list': 'complete_your_look',
              'position': i
          })
        }

        DataLayerUtils.push({
          'event': 'productImpression',
          'ecommerce': {
            'impressions': productImpression
          }
        });
      }
    }, 2000);
  }

}
